import React, { FC } from "react";

export const Header: FC = () => {
    return (
        <header>
            <span>{/* TITLE */}</span>

            <nav>{/* NAV */}</nav>
        </header>
    );
};
